import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ComponentRoutesEnum } from '@shared/utils/component-routes';
import { RestrictionTypeEnum } from '@main/age-restriction/utils/restriction-type.enum';
import { HttpErrorCodes } from '@shared/enums/error-codes.enum';
import { ERROR_CODES_ROUTES_CONFIG } from '@shared/services/error-handler/error-codes-routes.config';
import { LoaderService } from '../loader/loader.service';

@Injectable({
	providedIn: 'root'
})
export class ErrorHandlerService {
	public returnHomeTranslation: string;
	public returnWaitListTranslation: string;

	constructor(
		private router: Router,
		private translateService: TranslateService,
		private loaderService: LoaderService,
		@Inject('Window') private window: Window
	) {
		this.translateService
			.get('external-links.homepage')
			.subscribe((translation: string) => {
				this.returnHomeTranslation = translation;
			});
		this.translateService
			.get('sbb_newUserError_back_link')
			.subscribe((translation: string) => {
				this.returnWaitListTranslation = translation;
			});
	}

	/**
	 * Redirects to the selected error page
	 *
	 * @param page Error page to redirect to
	 */
	public goToErrorPage(page: ComponentRoutesEnum): void {
		let options;
		this.loaderService.hide();
		switch (page) {
		case ComponentRoutesEnum.AGE_RESTRICTION_BANKING:
			options = {
				state: {
					canNavigate: true,
					restrictionType: RestrictionTypeEnum.BANKING
				}
			};
			break;
		case ComponentRoutesEnum.AGE_RESTRICTION_DIRECTOR:
			options = {
				state: {
					canNavigate: true,
					restrictionType: RestrictionTypeEnum.DIRECTOR
				}
			};
			break;
		default:
			options = { state: { canNavigate: true } };
			break;
		}

		this.router.navigate([page], options);
	}

	public handleErrorResponse(err: any) {
		const targetRoute =
			ERROR_CODES_ROUTES_CONFIG[err?.error?.error?.code as HttpErrorCodes];
		this.loaderService.hide();
		if (targetRoute) {
			this.goToErrorPage(targetRoute);
		} else {
			this.genericError();
		}
	}

	/**
	 * Used to return the user to the EQ Bank home page
	 */
	public returnHome(): void {
		this.loaderService.hide();
		this.window.location.href = this.returnHomeTranslation;
	}

	public returnWaitList(): void {
		this.loaderService.hide();
		this.window.location.href = this.returnWaitListTranslation;
	}

	public genericError(): void {
		this.loaderService.hide();
		return this.goToErrorPage(ComponentRoutesEnum.GENERIC_ERROR_PAGE);
	}

	public ownershipRestriction(): void {
		this.loaderService.hide();
		return this.goToErrorPage(ComponentRoutesEnum.OWNERSHIP_RESTRICTION);
	}

	public quebecRestriction(): void {
		this.loaderService.hide();
		return this.goToErrorPage(ComponentRoutesEnum.QUEBEC_RESTRICTION);
	}
}
